import type { ThemeDefinition } from './types';

export const koodookaDark: ThemeDefinition = {
  id: 'koodooka-dark',
  name: 'Koodooka (Dark)',
  description: 'Koodooka brand dark theme — ink surfaces, bone typography, and glowing brick accents',
  mode: 'dark',
  tokens: {
    colorPrimary: '#CA5A43',
    colorPrimaryOnSidebar: '#CA5A43',
    colorPrimaryHover: '#D97861',
    colorPrimaryActive: '#B23E28',
    colorPrimaryBg: '#3A1711',
    colorFocus: '#B23E28',
    colorSecondary: '#CFC3BC',
    colorAccent: '#B23E28',
    colorSuccess: '#35A879',
    colorWarning: '#D6A23A',
    colorError: '#F06A6A',
    colorInfo: '#6EA8FE',
    colorBgBase: '#0B0B0C',
    colorBgContainer: '#171617',
    colorBgElevated: '#211E1C',
    colorBgSidebar: '#0B0B0C',
    colorText: '#FAF8F5',
    colorTextSecondary: '#CFC3BC',
    colorTextTertiary: '#A99B94',
    colorTextOnChrome: '#FAF8F5',
    colorTextInverse: '#0B0B0C',
    colorBorder: '#49302A',
    colorBorderSecondary: '#332522',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.30), 0 4px 12px rgba(178, 62, 40, 0.14)',
    boxShadowSecondary: '0 4px 16px rgba(0, 0, 0, 0.35), 0 8px 24px rgba(178, 62, 40, 0.14)',
    glassBlur: '16px',
    glassOpacity: '0.12',
    glassContentOpacity: '0.72',
    glassModalOpacity: '0.52',
    glassSaturation: '180%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyHeading: '"Instrument Serif", Georgia, serif',
    fontFamilyDisplay: '"Instrument Serif", Georgia, serif',
    fontFamilyMono: '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Menlo, Consolas, monospace',
    fontSize: 14,
    fontSizeHeading: 20,
    borderRadius: 8,
    borderRadiusLG: 16,
    cardBorder: '#49302A',
    cardShadow: '0 1px 3px rgba(0, 0, 0, 0.30)',
  },
};
